import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  CreateClassDTO,
  MasterApiService,
} from 'features/master-management/api/master-api.service';

import { MasterQueryKeys } from './query-keys';

const { createClass } = MasterApiService();

export const useCreateClassCategory = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateClassDTO) => {
      return createClass(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: MasterQueryKeys.lists(),
        });
      },
    },
  );
};
